import React, { useState } from 'react';
import { Button, ModalHeader, ModalBody, ModalFooter, Modal, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUnlock } from '@fortawesome/free-solid-svg-icons';
import { updatePassword } from '../../../api/users';
import { getCurrentToken } from '../../../reducer/store';
import {Store} from 'react-notifications-component';

const PasswordReset = ({userId}:{userId:string}) => {
    const [modal, setModal] = useState(false);
    const [contrasenia, setcontrasenia] = useState('');
    const token = getCurrentToken();

    const actualizarContrasenia = async() => {
        const res = await updatePassword(token, userId, contrasenia);
        if(res.data === 'OK'){
            toggle();
            Store.addNotification({
                title: 'Excelente',
                message: 'La contraseña fue modificada con éxito',
                type: 'success',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animate__animated', 'animate__fadeIn'],
                animationOut: ['animate__animated', 'animate__fadeOut'],
                dismiss: {
                  duration: 5000,
                  onScreen: true,
                },
              });
        }
    }

    const toggle = () => setModal(!modal);
    return (
        <>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>Reiniciar Contraseña</ModalHeader>
                <ModalBody>
                    <Input
                        placeholder='Ingrese una nueva Contraseña'
                        type="password"
                        value={contrasenia}
                        onChange={(event) =>
                            setcontrasenia(event.target.value)
                        }
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={actualizarContrasenia}>
                        Guardar
                    </Button>{' '}
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Button onClick={toggle}> <FontAwesomeIcon icon={faUnlock} /></Button>
        </>
    );
};

export default PasswordReset;